import {useThemeColors} from '@nfq/colors';

/**
 * Custom hook that provides theme colors for hint components.
 *
 * @returns An object containing the theme colors.
 */
export const useHints = () => {
    const colors = useThemeColors();

    return {colors};
};